
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CitiesService } from '../../../services/apiclient/cities/cities.service';
import { debounceTime, switchMap, tap, filter } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { PointofsaleService } from 'src/app/services/api/pointofsale/pointofsale.service';
import { Observable, fromEvent } from 'rxjs';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import * as _ from "lodash";

@Component({
  selector: 'app-check-address',
  templateUrl: './check-address.component.html',
  styleUrls: ['./check-address.component.css']
})

export class CheckAddressComponent implements OnInit {

  @ViewChild('autoCompletePostal', { read: MatAutocompleteTrigger, static: true }) acPostal: MatAutocompleteTrigger | any;
  @ViewChild('selectCities', { read: MatSelect }) inputCities: MatSelect | any;

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  checkCityForm: FormGroup | any;

  validCities: any;
  checkValid: boolean = false;
  unavailablePostal: boolean = false;

  currDelivryZone: any;

  currPointOfSale: any = this.tools.getStor("point_of_sale");

  filteredPostals: Observable<any> | any;
  filteredCities: Observable<any> | any;

  loaders: any = {
    postals: false,
    cities: false,
    eligible: false
  }

  fromSmDial: boolean;
  // Pays
  countries$: any[] | any;
  countries: any[] | any;
  // Pays séléctionné
  selectedCountry: any;
  error_elligible_city=false;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private formBuilder: FormBuilder,
    private cityApi: CitiesService,
    private posApi: PointofsaleService,
    private tools: ToolsService,
    public dialogMan: DialogsService,
    public dialogRef: MatDialogRef<CheckAddressComponent>,
    private countriesApi: CountriesService
  ) {
    this.fromSmDial = data.fromSmDial;
  }

  ngOnInit() {
  
    this.onWindowResize();
    this.getCountries();
    this.createcheckCityForm();
    this.tools.removeStor("countriesEligible");

  }





  /**
   * @description récupere les pays
   * @return {Void}
   */
  getCountries(): void {
    this.loaders.countries = true;
    this.countriesApi.getCountries().subscribe(countries => {
      this.countries$ = countries;
      this.loaders.countries = false;

      //villes
      this.getCities();

    })
  }

  /**
   * @description récupere les villes eligibles à la livraison
   * @return {Void}
   */
  getCities() {

   

    this.posApi.$_getEligibleCities(this.currPointOfSale.id_webshop).then((data) => {

        if (data && data.length > 0) {
          this.currPointOfSale.eligible_zones = data;
       


          //on cree le tableau des pays eligibles à la livraison
          this.setCountryEligible_zones();


          this.tools.setStor("point_of_sale", this.currPointOfSale);

          this.validCities = data;
          this.getPostalsOnChange();
        }
        else{
          this.error_elligible_city=true;
        }

      }

    )
  }

  /**
   * @description set CountryEligible_zones select
   * @return {Void}
   */

  setCountryEligible_zones() {

    // On set l'array associatif des country
    const newParsedcountry: any = [];

    for (let i = 0; i < this.currPointOfSale.eligible_zones.length; i++) {
      const item: any = this.currPointOfSale.eligible_zones[i];

      let country: any = {
        id_country: item.city.id_country,
        cities: 1
      }

      newParsedcountry[item.city.id_country] ? newParsedcountry[item.city.id_country].cities += 1
        : newParsedcountry[item.city.id_country] = country;

    }



    //transform en array
    let result_countries = Object.keys(newParsedcountry).map(key => (newParsedcountry[key]));





    //sort les cities par leurs nombres
    if (result_countries.length > 0) {
      _.orderBy(result_countries, 'cities', 'asc');

    }


    //set default flag and name
    this.setDefaultDatacountries(result_countries);


  }

  /**
   * @description set default select
   * @param {countries}
   */
  setDefaultDatacountries(countries: any) {
   


    //flag et name
    countries.map((country: any) => {

      let count: any = this.countries$.find((value: any) => value.id == country.id_country);
      if (count) {
        country.flag = count.flag,
          country.name = count.name
      }
    });



    // sort si meme nombre de ville avec le country du compte et la premiere position
    // on place en premier la contry du compte


    const index = countries.findIndex((value: any) => value.id_country == this.currPointOfSale.id_country);

    if (index > 0 && countries[0].cities == countries[index].cities) {
      const value = countries[index];
      countries.splice(index, 1);
      countries.unshift(value);
    }



    this.countries = countries;

    this.tools.setStor("countriesEligible", this.countries);


    //on set le selected country
    this.setSelectedCountry(this.countries[0]);

  }




  /**
   * @description Incrémente la variable selectedCountry avec un object country
   * @param {Country} country
   * @return {Void}
   */
  setSelectedCountry(country: any): void {

    this.selectedCountry = country;
    
    // Set le select  id_country (le form)
    this.checkCityForm.get("country").setValue(this.selectedCountry.id_country);

    //reset postal and city
    this.removePostal();


  }



  createcheckCityForm() {
    this.checkCityForm = this.formBuilder.group({
      postal: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
    });

  }

  selectedDataValue($ev: any) {
    this.removePostal();
  }

  isFieldrequired(field: string) {
    let thisField = this.checkCityForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }

    return

  }


  getPostalsOnChange(): void {

    this.checkCityForm.get("postal").valueChanges
      .pipe(
        filter((v: any) => v && v.length > 3),
        debounceTime(200),
        tap(() => {
          this.loaders.postals = true;
        }),
        switchMap((value: any) => this.cityApi.getPostals(this.selectedCountry.id_country, value))


      ).subscribe((postals: any) => {

        this.filteredPostals = (postals.length > 0) ? postals : null;

        if (this.filteredPostals) {

          this.onSelectPostal(this.filteredPostals[0]);
          this.unavailablePostal = false;

        } else {

          this.unavailablePostal = true;
          this.removeCity();

        }

        this.loaders.postals = false;

      });

  }

  onSelectPostal(postal: any): void {
    const cityInput = this.checkCityForm.get("city");
    this.removeCity();
    this.loaders.cities = true;

    this.cityApi.getCities(this.selectedCountry.id_country, postal).then(cities => {

      if (cities.length > 0) {
        this.filteredCities = cities;
        if (cities.length === 1) {
          cityInput.setValue(cities[0].id);
          this.checkCityOnChange();
        }
      }

      setTimeout(() => {
        this.inputCities.focus();
        if (cities.length > 1) { this.inputCities.toggle(); }
      });

      this.loaders.cities = false;

    });

  }

  checkCityOnChange() {

    const cityInput = this.checkCityForm.get("city");
    let isEligible = false;
    this.loaders.eligible = true;

    setTimeout(() => {
      this.validCities.map((city: any) => {
        if (city.id_city === cityInput.value) {
          this.currDelivryZone = city;
          isEligible = true;
        }
      });

      this.checkValid = isEligible;
      this.loaders.eligible = false;

    }, 500);

  }

  onTabKey() {
    if (this.filteredPostals) {
      this.checkCityForm.get('postal').setValue(this.filteredPostals[0]);
      this.onSelectPostal(this.filteredPostals[0]);
    }
  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }

  removePostal() {
    this.filteredPostals = null;
    this.checkCityForm.get("postal").reset();
    this.checkCityForm.get("postal").setValue("");
    this.removeCity();
  }

  removeCity() {
    this.filteredCities = null;
    this.checkCityForm.get("city").reset();
    this.checkCityForm.get("city").setValue("");

  }

}
